/**
 * 說明 : 客戶資料和機械關係與後端API調用的非同步行為
 */
import {createAsyncThunk} from '@reduxjs/toolkit';

import BaseAPI from './BaseAPI';

// 取得角色權限清單列表
export const fetchRelCustomerMachineSelection = createAsyncThunk(
  'relCustomerMachine/fetchRelCustomerMachineSelection',
  async ({customerCode, isEnabled}, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.getWithAuth(
        '/selection/relCustomerMachine',
        {customerCode, isEnabled},
        token,
      );
      return data;
    } catch (err) {
      console.error('fetch relCustomerMachine list error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 取得機器分配資料列表
export const fetchMachineAssignments = createAsyncThunk(
  'machineAssignment/fetchMachineAssignments',
  async (
    {customerCode, deliveryCode, machineSerialNumber, machineTypeId},
    {getState, rejectWithValue},
  ) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.getWithAuth(
        '/machine-assignments',
        {customerCode, deliveryCode, machineSerialNumber, machineTypeId},
        token,
      );
      return data;
    } catch (err) {
      console.error('fetch relCustomerMachine list error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);
